export default "__VITE_ASSET__CvepgXda__"